import type { WizardFlowStepDefinition } from '@/modules/wizard/types/WizardFlowStepDefinition'
import type { WizardSavedProgress } from '@/modules/wizard/types/WizardSavedProgress'

/**
 * Maps saved progress to an index in `steps`. A step id resolves wherever the
 * step sits now, so inserting or reordering steps keeps users on their step.
 * A legacy index is taken as-is while it is in range. Anything else (no
 * progress, a removed step, an out-of-range index) starts the flow at 0.
 */
export const resolveSavedStepIndex = (
  steps: readonly WizardFlowStepDefinition[],
  saved: WizardSavedProgress | null,
): number => {
  if (typeof saved === 'string') {
    const index = steps.findIndex((step) => step.id === saved)
    return index === -1 ? 0 : index
  }

  if (
    typeof saved === 'number' &&
    Number.isInteger(saved) &&
    saved >= 0 &&
    saved < steps.length
  ) {
    return saved
  }

  return 0
}
